import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditProductRes } from "./helper";

export const editProduct = async (params: { id: number; data: ProductReqT }) =>
  axios.put(Routes.EDIT_PRODUCT + "/" + params.id, { ...params.data });

export const useEditProduct = () =>
  useMutation({
    mutationKey: [Keys.EDIT_PRODUCT_MUT],
    mutationFn: editProduct,
    onSuccess: onEditProductRes,
  });
